import { LANGUAGES } from '../constants/index.js';
import { ModelLanguageRegistry } from '../modelLanguage/index.js';
/**
 * 获取所有支持的语言列表
 */
export function getAllLanguages() {
    return [...LANGUAGES];
}
/**
 * 获取可用作源语言的语言列表
 * @param modelId 可选的模型ID，如果提供，则返回该模型支持的源语言
 */
export function getSourceLanguages(modelId) {
    if (modelId) {
        return ModelLanguageRegistry.getInstance().getModelSourceLanguages(modelId);
    }
    // 默认只返回自动检测选项 (Default to only returning the auto-detect option)
    return LANGUAGES.filter(lang => lang.isAuto);
}
/**
 * 获取可用作目标语言的语言列表(不包含自动检测) (Get the list of languages available as target languages (excluding auto-detect))
 * @param modelId 可选的模型ID，如果提供，则返回该模型支持的目标语言
 */
export function getTargetLanguages(modelId) {
    if (modelId) {
        return ModelLanguageRegistry.getInstance().getModelTargetLanguages(modelId);
    }
    return LANGUAGES.filter(lang => !lang.isAuto);
}
/**
 * 根据语言代码获取语言对象
 */
export function getLanguageByCode(code) {
    return LANGUAGES.find(lang => lang.code === code);
}
/**
 * 获取语言名称
 */
export function getLanguageName(code) {
    const language = getLanguageByCode(code);
    return language?.name || code;
}
//# sourceMappingURL=languageUtils.js.map